import React, { ReactElement } from 'react';
import { Tabs as UiTabs, TabsContent, TabsList, TabsTrigger } from '@crisp/crisp-ui/cabbage';
import { Icon } from './Icon';
import styles from './Tabs.module.css';

export interface TabProps {
  title: string;
  icon?: string;
  children?: React.ReactNode;
  className?: string;
}

export const Tab: React.FC<TabProps> = ({ children }) => {
  return <>{children}</>;
};

export interface TabsProps {
  children?: React.ReactNode;
  defaultIndex?: number;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ children, defaultIndex = 0, className = '' }) => {
  const tabs = React.Children.toArray(children).filter(
    (child): child is ReactElement<TabProps> =>
      React.isValidElement(child) && typeof child.props === 'object'
  );

  if (tabs.length === 0) {
    return <div className={className}>{children}</div>;
  }

  return (
    <UiTabs defaultValue={String(defaultIndex)} className={`${styles.root} ${className}`.trim()}>
      <TabsList variant="line">
        {tabs.map((tab, idx) => (
          <TabsTrigger key={idx} value={String(idx)}>
            {tab.props.icon ? <Icon name={tab.props.icon} /> : null}
            {tab.props.title || `Tab ${idx + 1}`}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab, idx) => (
        <TabsContent key={idx} value={String(idx)} className={styles.panel}>
          {tab.props.children}
        </TabsContent>
      ))}
    </UiTabs>
  );
};

export default Tabs;
